import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { CancelButton } from 'components/ui/Button';

const BlockTicketsWithExtraLuggageWarning = ({ isOpen, closeModal }) => (
  <Modal
    isOpen={isOpen}
    title={<FormattedMessage id="searchResults.cannotBeBooked" />}
    subtitle={<FormattedMessage id="journeySegment.blockAddingLuggage" />}
    onClose={closeModal}
    bottomRow={
      <CancelButton data-cy="cancel" onClick={closeModal}>
        <FormattedMessage id="manageBooking.cancel" />
      </CancelButton>
    }
  ></Modal>
);

BlockTicketsWithExtraLuggageWarning.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  subtitle: PropTypes.string
};

export default BlockTicketsWithExtraLuggageWarning;
